export default "__VITE_ASSET__CeoEqxhc__"